import {  useState, useEffect, useRef } from "react";
import { Form,Button } from 'reactstrap';
import { APILA } from "../../../../../../config/apila";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import LoaderAction from "../../../../../Loader/LoaderHome";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

export default function ModalKkcaUpdate(props) {
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const safeValue = (value) => value ?? "";

  const [form, setForm] = useState({
    name_kkca: "",
    persentase: "",
    user_id:"",
   
  });


  // =========================================
  // MENGISI DATA UPDATE
  // =========================================
  useEffect(() => {
    if (!props?.show) {
      return;
    }

    setForm({
      name_kkca: safeValue(
        props?.dataUpdate?.name_kkca
      ),

      persentase: safeValue(
        props?.dataUpdate
          ?.persentase
      ),
    });
  }, [props?.show, props?.dataUpdate]);


  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APILA.put(`/api/kkca/${props.id}`, {
        name_kkca: form?.name_kkca,
        persentase: form?.persentase,
        user_id: idUser,
      }, fetchParams);
  
      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: 'success',
          title: response.data.message,
        })
        props.GetResponseData();
        props.onHide();
      }

    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-kkca"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-update-kkca" className="sims-modal-title">
            Update KKCA
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="kkca_update">
              Nama KKCA <span>*</span>
            </label>
            <input
              id="kkca_update"
              className="sims-form-input"
              autoFocus
              required
              autoComplete="off"
              type="text"
              name="name_kkca"
              onChange={handleChange}
              value={form.name_kkca}
            />
          </div>

          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="persentase_update">
              Persentase <span>*</span>
            </label>
            <input
              id="persentase_update"
              className="sims-form-input"
              required
              autoComplete="off"
              type="text"
              name="persentase"
              onChange={handleChange}
              value={form.persentase}
            />
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Perbarui
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
  